const TrustTypes = {
  irrevocableTrust: {
    id: 1,
    name: 'irrevocableTrust',
    text: 'Irrevocable trust',
    key: 'IRREVOCABLE_TRUST',
  },
  revocableTrust: {
    id: 2,
    name: 'revocableTrust',
    text: 'Revocable trust',
    key: 'REVOCABLE_TRUST',
  },
  testamentaryTrust: {
    id: 3,
    name: 'testamentaryTrust',
    text: 'Testamentary trust',
    key: 'TESTAMENTARY_TRUST',
  },
  other: {
    id: 7,
    name: 'other',
    text: 'Other',
    key: 'OTHER',
  },
};

export default TrustTypes;



// WEBPACK FOOTER //
// ./src/data/static/trustTypes.js